import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/groups?paginate=true`

    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ tenantID, groupID }) {
    return authenticated({
      url: `/tenants/${tenantID}/groups/${groupID}`,
      method: 'get'
    })
  },
  store({ tenantID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/groups`,
      method: 'post',
      data
    })
  },
  update({ tenantID, groupID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/groups/${groupID}`,
      method: 'patch',
      data
    })
  },
  destroy({ tenantID, groupID }) {
    return authenticated({
      url: `/tenants/${tenantID}/groups/${groupID}`,
      method: 'delete'
    })
  },
  relateModules({ tenantID, groupID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/groups/${groupID}/modules`,
      method: 'post',
      data
    })
  },
  relateMembers({ tenantID, groupID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/groups/${groupID}/tenant-users`,
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/groups.js